<template>
  <div>
    <!-- basic modal -->
    <b-modal
      id="special-product-modal"
      ref="special-product-modal"
      title="Özel Ürün Düzenle"
      size="md"
      hide-footer
    >
      <SpecialProductEditor :products-data="productData.packet_data" />
    </b-modal>
    <b-modal
      id="tax-types-modal"
      v-model="showTaxTypeEditor"
      size="lg"
      hide-footer
      :title="$t('Vergi Türleri')"
    >
      <tax-types
        :show="showTaxTypeEditor"
        @dataChanged="taxTypeDataChanged"
      /></b-modal>
    <!-- depolar modal -->
    <b-modal
      id="stores-modal"
      v-model="showStoreEditor"
      size="xl"
      hide-footer
      :title="$t('Depo Tanımları')"
    >
      <stores
        :show="showStoreEditor"
        @dataChanged="storeDataChanged"
      /></b-modal>
    <!-- Kategorü düzenleme modal -->
    <b-modal
      id="categories-modal"
      v-model="showCategoriyEditor"
      size="lg"
      hide-footer
      :title="$t('Ürün Kategorileri')"
    >
      <category-list
        :show="showCategoriyEditor"
        @dataChanged="categoryDataChanged"
      /></b-modal>
    <!-- BODY -->
    <validation-observer
      #default="{ handleSubmit }"
      ref="refFormObserver"
    >
      <!-- Form -->
      <b-form
        v-if="productData"
        class="p-2"
        @submit.prevent="handleSubmit(saveData)"
        @reset.prevent="resetForm"
      >
        <b-row>
          <b-col md="12">
            <b-alert
              v-if="productData.discount_type!=0"
              variant="warning"
              show
            >
              <div class="alert-body">
                <span><strong>Bu üründe bir kampanya fiyatı tanımlı. Lütfen fiyat alanını kontrol edim</strong> </span>
              </div>
            </b-alert>
            <b-alert
              v-if="productData.price<=0"
              variant="warning"
              show
            >
              <div class="alert-body">
                <span><strong>Bu ürüne fiyat girilmedi. Mağazada "Temsilcinize Sorunuz" olarak görünecek.</strong> </span>
              </div>
            </b-alert>
            <b-alert
              v-if="productData.is_draft==1"
              variant="warning"
              show
            >
              <div class="alert-body">
                <span><strong>Bu ürün taslak durumunda. Mağazada gösterilmeyecek.</strong> </span>
              </div>
            </b-alert>
          </b-col>
          <b-col md="8">
            <!-- Taslak mı  -->
            <b-form-group>
              <b-form-checkbox
                id="is_draft"
                v-model="productData.is_draft"
                class="custom-control-primary"
                name="check-button"
                :value="1"
                :unchecked-value="0"
              >
                {{ $t('Taslak (Taslak olan ürünler kullanılamaz)') }}
              </b-form-checkbox>

            </b-form-group>
            <b-form-group :label="$t('Ürün Türü')">
              <b-form-select
                v-model="productData.product_type"
                :options="productTypeOptions"
              />
            </b-form-group>
            <div v-if="productData.product_type==1">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                block
                variant="outline-primary"
                @click="addPacketProduct();"
              >
                Pakete Ürün Ekle
              </b-button>
              <hr>
              <b-list-group>
                <b-list-group-item
                  v-for="(listItem,index) in productData.packet_data"
                  :key="index"
                  class="d-flex justify-content-between align-items-center"
                  tag="li"
                >
                  <div class="d-flex">
                    <b-img
                      style="max-height:20px;"
                      :src="listItem.image"
                    />
                    <div class="ml-25">
                      <b-card-text class="font-weight-bold mb-0">
                        {{ listItem.name }} -
                      </b-card-text>

                    </div>

                  </div>
                  <b-form-input
                    id="product-quantity"
                    v-model="listItem.quantity"
                    type="text"
                    :placeholder="$t('Adet Giriniz')"
                    :readonly="false"
                  />  adet
                  <b-button
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="flat-danger"
                    class="btn-icon"
                    @click="productData.packet_data.splice(index,1)"
                  >
                    <feather-icon icon="TrashIcon" />
                  </b-button>
                </b-list-group-item>
              </b-list-group>
              <hr>
            </div>
            <!-- Stok Kodu -->
            <validation-provider
              #default="validationContext"
              :name="$t('Stok Kodu')"
              rules="required|min:2"
            >
              <b-form-group
                :label="$t('Stok Kodu')"
                label-for="code"
              >
                <b-form-input
                  id="name"
                  v-model="productData.stock_code"
                  autofocus
                  :readonly="productData.creator!=1"
                  autocomplete="off"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <!-- Ürün Adı -->
            <validation-provider
              #default="validationContext"
              :name="$t('Ürün Adı')"
              rules="required|min:2"
            >
              <b-form-group
                :label="$t('Ürün Adı')"
                label-for="name"
              >
                <b-form-input
                  id="name"
                  v-model="productData.name"
                  autofocus
                  :readonly="productData.creator!=1"
                  autocomplete="off"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <b-form-group
              :label="$t('Ürün Açıklaması')"
              label-for="description"
            >
              <quill-editor
                id="description"
                v-model="productData.description"
                :options="snowOption"
              />
            </b-form-group>
            <!-- Taslak mı  -->
            <b-form-group>
              <b-form-checkbox
                id="update_via_api"
                v-model="productData.update_via_api"
                class="custom-control-primary"
                name="check-button"
                :value="1"
                :unchecked-value="0"
              >
                {{ $t('Xml ile güncelle') }}
              </b-form-checkbox>

            </b-form-group>
            <!-- Taksit İzni  -->
            <b-form-group>
              <b-form-checkbox
                id="is_installment"
                v-model="productData.is_installment"
                class="custom-control-primary"
                name="check-button"
                :value="1"
                :unchecked-value="0"
              >
                {{ $t('Bu ürüne taksit yapılmasına izin ver') }}
              </b-form-checkbox>

            </b-form-group>
            <!-- Tek Çekim İzni -->
            <b-form-group>
              <b-form-checkbox
                id="is_buyable_credit_limit"
                v-model="productData.is_buyable_credit_limit"
                class="custom-control-primary"
                name="check-button"
                :value="1"
                :unchecked-value="0"
              >
                {{ $t('Bu ürünü açık hesap ile almaya izin ver') }}
              </b-form-checkbox>

            </b-form-group>
            <validation-provider
              #default="validationContext"
              :name="$t('Tek Çekim İndirimi')"
              rules="required"
            >
              <b-form-group
                :label="$t('Tek Çekim İndirimi')"
                label-for="advance_discount"
              >
                <b-input-group>
                  <cleave
                    id="advance_discount"
                    v-model="productData.advance_discount"
                    size="lg"
                    :state="getValidationState(validationContext)"

                    class="form-control"
                    right

                    :options="priceInputConfig"
                  />
                  <b-input-group-append is-tex>
                    <span>%</span>
                  </b-input-group-append>
                </b-input-group>

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <validation-provider
              #default="validationContext"
              :name="$t('Havale & Eft İndirimi')"
              rules="required"
            >
              <b-form-group
                :label="$t('Havale & Eft İndirimi')"
                label-for="bank_transfer_discount"
              >
                <b-input-group>
                  <cleave
                    id="bank_transfer_discount"
                    v-model="productData.bank_transfer_discount"
                    size="lg"
                    :state="getValidationState(validationContext)"

                    class="form-control"
                    right

                    :options="priceInputConfig"
                  />
                  <b-input-group-append is-text>
                    <span>%</span>
                  </b-input-group-append>
                </b-input-group>

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <b-form-group />
            <!-- Form Actions -->
            <div class="d-flex mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                type="submit"
              >
                {{ $t('Kaydet') }}
              </b-button>
            </div>

          </b-col>
          <b-col
            md="4"
          >
            <b-card
              no-body
              class="border mt-1"
            >
              <b-card-header class="p-1">
                <b-card-title class="font-medium-2">
                  <feather-icon
                    icon="InfoIcon"
                    size="18"
                  />
                  <span class="align-middle ml-50">{{ $t('Ürün Genel Bilgileri') }}</span>
                </b-card-title>
              </b-card-header>
              <b-card-body>

                <!-- ürün stokları -->
                <validation-provider

                  :name="$t('Stok')"
                >
                  <div class="d-flex align-items-center justify-content-end">
                    <b-button
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"

                      variant="flat-primary"
                      @click="showStoreEditor=true"
                    >
                      <feather-icon icon="EditIcon" />
                      {{ $t('Depoları Düzenle') }}
                    </b-button>
                  </div>

                  <b-row
                    v-for="(item) in productData.stock_data"
                    :id="item.id"
                    :key="item.id"
                    ref="row"
                  >

                    <!-- Item Name -->
                    <b-col md="12">
                      <b-form-group>
                        <b-input-group>
                          <b-form-input
                            id="item-name"
                            v-model="item.store_name"
                            type="text"
                            :placeholder="$t('Depo')"
                            :readonly="true"
                          />
                          <b-input-group-append>
                            <b-form-input
                              id="item-stock"
                              v-model="item.stock"
                              type="number"
                              :placeholder="$t('Stok')"
                            />
                          </b-input-group-append>
                        </b-input-group>

                      </b-form-group>
                    </b-col>

                  </b-row>
                </validation-provider>
                <!-- Alış Fiyatı -->
                <validation-provider
                  #default="validationContext"
                  :name="$t('Alış Fiyatı')"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('Alış Fiyatı')"
                    label-for="price"
                  >
                    <b-input-group>
                      <cleave
                        id="price"
                        v-model="productData.purchase_price"
                        size="lg"
                        :state="getValidationState(validationContext)"

                        class="form-control"
                        right

                        :options="priceInputConfig"
                      />
                      <b-input-group-append>
                        <b-form-select
                          v-model="productData.currency_type"
                          :options="currencyOptions"
                        />
                      </b-input-group-append>
                    </b-input-group>

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
                <!-- Fiyat -->
                <validation-provider
                  #default="validationContext"
                  :name="$t('Fiyat')"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('Fiyat')"
                    label-for="price"
                  >
                    <b-input-group>
                      <cleave
                        id="price"
                        v-model="productData.price"
                        size="lg"
                        :state="getValidationState(validationContext)"

                        class="form-control"
                        right

                        :options="priceInputConfig"
                      />
                      <b-input-group-append>
                        <b-form-select
                          v-model="productData.currency_type"
                          :options="currencyOptions"
                        />
                      </b-input-group-append>
                    </b-input-group>

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
                <b-form-group
                  :label="$t('İndirim Türü')"
                  label-for="price"
                >
                  <b-form-select
                    v-model="productData.discount_type"
                    :options="$staticParams.discountOptions"
                  />
                </b-form-group>
                <b-form-group v-if="productData.discount_type!=0">
                  <b-form-checkbox
                    id="discount_include_bank_transfer_and_advance_discount"
                    v-model="productData.discount_include_bank_transfer_and_advance_discount"
                    class="custom-control-primary"
                    name="check-button"
                    :value="1"
                    :unchecked-value="0"
                  >
                    {{ $t('İndirimli fiyata varsa havale ve tek çekim indirimini dahil et.') }}
                  </b-form-checkbox>
                </b-form-group>
                <b-form-group
                  v-if="productData.discount_type==2"
                  :label="$t('Başlangıç Tarihi')"
                  label-for="discount_start_date"
                >
                  <b-form-datepicker
                    id="discount_start_date"
                    v-model="productData.discount_start_date"
                    class="mb-1"
                  />
                </b-form-group>
                <b-form-group
                  v-if="productData.discount_type==2"
                  :label="$t('Bitiş Tarihi')"
                  label-for="discount_end_date"
                >
                  <b-form-datepicker
                    id="discount_end_date"
                    v-model="productData.discount_end_date"
                    class="mb-1"
                  />
                </b-form-group>
                <!-- İndirimli Fiyat -->
                <validation-provider
                  v-if="productData.discount_type!=0"
                  #default="validationContext"
                  :name="$t('İndirimli Fiyat')"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('İndirimli Fiyat')"
                    label-for="price"
                  >
                    <b-input-group>
                      <cleave
                        id="price"
                        v-model="productData.discounted_price"
                        size="lg"
                        :state="getValidationState(validationContext)"

                        class="form-control"
                        right

                        :options="priceInputConfig"
                      />

                    </b-input-group>

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
                <!-- Birim -->
                <validation-provider
                  #default="validationContext"
                  :name="$t('Birim')"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('Birim')"
                    label-for="unit_type"
                  >

                    <b-form-select
                      v-model="productData.unit_type"
                      :options="unitOptions"
                      :state="getValidationState(validationContext)"
                      :readonly="productData.creator!=1"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
                <!-- Vergi Türü -->
                <validation-provider
                  #default="validationContext"
                  :name="$t('Vergi Türü')"
                  rules="required"
                >
                  <div class="d-flex align-items-center justify-content-end">
                    <b-button
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      v-b-modal.tax-types-modal
                      variant="flat-primary"
                    >
                      <feather-icon icon="EditIcon" />
                      {{ $t('Vergi Türlerini Düzenle') }}
                    </b-button>
                  </div>

                  <b-form-group
                    :label="$t('Vergi Türü')"
                    label-for="tax_type"
                  >

                    <b-form-select
                      v-model="productData.tax_type"
                      :options="taxTypesData"
                      :state="getValidationState(validationContext)"
                      :readonly="productData.creator!=1"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
                <!-- Vergi Türü -->
                <validation-provider
                  #default="validationContext"
                  :name="$t('Marka')"
                >

                  <b-form-group
                    :label="$t('Marka')"
                    label-for="brand"
                  >

                    <b-form-select
                      v-model="productData.brand_id"
                      :options="brandsData"
                      :state="getValidationState(validationContext)"
                      :readonly="productData.creator!=1"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
                <!-- Kategori -->
                <validation-provider
                  #default="validationContext"
                  :name="$t('Kagetori')"
                >

                  <b-form-group
                    :label="$t('Kategori')"
                    label-for="category_id"
                  >

                    <v-select
                      id="category_id"
                      v-model="productData.category_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="categoriesData"
                      :reduce="val => val.value"
                      label="text"
                      :clearable="false"
                      input-id="category_id"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
                <validation-provider
                  #default="validationContext"
                  :name="$t('Diğer Kategoriler')"
                >

                  <b-form-group
                    :label="$t('Diğer Kategoriler')"
                    label-for="other_categories"
                  >

                    <v-select
                      id="other_categories"
                      v-model="productData.other_category_ids"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      multiple
                      :options="categoriesData"
                      :reduce="val => val.value"
                      label="text"
                      :clearable="false"
                      input-id="other_categories"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-card-body>
            </b-card>
          </b-col>

        </b-row>
      </b-form>

    </validation-observer>
  </div>
</template>

<script>
import {
  BAlert, BFormDatepicker, BForm, BFormGroup, BModal, VBModal, BInputGroupAppend, BFormSelect, BListGroup, BInputGroup, BCard, BCardBody, BCardHeader, BCardTitle, BFormInput, BFormInvalidFeedback, BRow, BCol, BButton, BFormTextarea, BFormCheckbox, BCardText, BImg, BListGroupItem,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import vSelect from 'vue-select'
import { quillEditor } from 'vue-quill-editor'
import { ref } from '@vue/composition-api'
import Cleave from 'vue-cleave-component'
import taxTypes from './product-tax-types/TaxTypes.vue'
import stores from './product-stores/Stores.vue'
import categoryList from '../product-categories/CategoryList.vue'
import SpecialProductEditor from './SpecialProductEditor.vue'

export default {
  components: {
    BForm,
    BAlert,
    BFormCheckbox,
    BRow,
    taxTypes,
    SpecialProductEditor,
    stores,
    BModal,
    BListGroup,
    BFormSelect,
    BCardBody,
    BCol,
    BCard,
    BCardHeader,
    BCardText,
    BImg,
    BListGroupItem,
    BCardTitle,
    quillEditor,
    categoryList,
    Cleave,
    BInputGroup,
    BInputGroupAppend,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    // eslint-disable-next-line vue/no-unused-components
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    BFormTextarea,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    BFormDatepicker,
  },
  directives: {
    Ripple,
    'b-modal': VBModal,
  },
  mixins: [togglePasswordVisibility],
  model: {
    prop: 'isEditProductSidebarActive',
    event: 'update:is-edit-product-sidebar-active',
  },
  props: {
    blankProductData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      showTaxTypeEditor: false,
      showCategoriyEditor: false,
      showStoreEditor: false,
      productTypeOptions: [
        { value: 0, text: 'Normal Ürün' },
        { value: 1, text: 'Paket Ürün' },
      ],
    }
  },
  watch: {
    showCategoriyEditor(val) {
      if (val === false) {
        this.fetchCategories()
      }
    },
  },
  methods: {
    addPacketProduct() {
      this.$refs['special-product-modal'].show()
    },
    showSuccessMessage() {
      this.$bvToast.toast(this.$t('İşlem Başarılı'), {
        title: this.$t('İşlem Başarılı'),
        variant: 'success',
        solid: false,
      })
    },
    showErrorMessage() {
      this.$bvToast.toast(this.$t('İşlem Başarısız'), {
        title: this.$t('İşlem Başarısız'),
        variant: 'danger',
        solid: false,
      })
    },
    makeproductData() {
      this.productData = JSON.parse(JSON.stringify(this.blankProductData))
    },

    taxTypeDataChanged(taxTypesData) {
      this.taxTypesData = []
      taxTypesData.forEach(val => {
        this.taxTypesData.push({ text: val.name, value: val.id })
      })
    },
    storeDataChanged(taxTypesData) {
      this.taxTypesData = []
      taxTypesData.forEach(val => {
        this.taxTypesData.push({ text: val.name, value: val.id })
      })
    },
    // eslint-disable-next-line no-unused-vars
    categoryDataChanged(categoriesDAta) {
    },
    saveData() {
      if (this.productData.discount_type === 2 && (this.productData.discount_start_date == null || this.productData.discount_end_date == null)) {
        this.$bvToast.toast(this.$t('Kampanya başlangıç ve bitiş tarihi seçiniz.'), {
          title: this.$t('İşlem Başarısız'),
          variant: 'danger',
          solid: false,
        })
        return
      }
      if (this.productData.tax_type === 0) {
        this.$bvToast.toast(this.$t('Lütfen vergi türü seçiniz'), {
          title: this.$t('İşlem Başarısız'),
          variant: 'danger',
          solid: false,
        })
        return
      }
      store.dispatch('app-product/updateProduct', this.productData)
      // eslint-disable-next-line no-unused-vars
        .then(response => {
          this.showSuccessMessage()
        })
        .catch(() => {
          this.showErrorMessage()
        })
    },
  },
  // eslint-disable-next-line no-unused-vars
  setup(props, { emit }) {
    // fetch user
    const countryOptions = ref(null)
    const managersList = ref([])
    const productData = ref(null)
    const currencyOptions = ref([])
    const unitOptions = ref([])
    const categoriesData = ref([])
    const taxTypesData = ref([])
    const brandsData = ref([])
    store.dispatch('app/fetchTaxTypes', {})
      .then(response => {
        const arr = []

        response.data.data.forEach(val => {
          arr.push({ text: val.name, value: val.id })
        })
        taxTypesData.value = arr
      })
      .catch(error => {
        if (error.response.status === 404) {
          taxTypesData.value = null
        }
      })
    const fetchCategories = () => {
      store.dispatch('app-product/fetchCategories', { list_type: 'all' })
        .then(response => {
          const arr = []
          response.data.data.forEach(val => arr.push({ text: val.name_with_parents, value: val.id }))
          categoriesData.value = arr
        })
    }
    const fetchBrands = () => {
      store.dispatch('app-product/fetchBrands', { list_type: 'all' })
        .then(response => {
          const arr = []
          response.data.data.forEach(val => arr.push({ text: val.name, value: val.id }))
          brandsData.value = arr
        })
    }
    fetchCategories()
    fetchBrands()
    store.dispatch('app/fetchCurrencyTypes', {})
      .then(response => {
        const arr = []
        response.data.data.forEach(val => arr.push({ text: val.name, value: val.id }))
        currencyOptions.value = arr
      })
    store.dispatch('app/fetchUnitTypes', {})
      .then(response => {
        const arr = []
        response.data.data.forEach(val => arr.push({ text: val.name, value: val.id }))
        unitOptions.value = arr
      })
    const onSubmit = () => {

    }
    const resetproductData = () => {
      productData.value = JSON.parse(JSON.stringify(props.blankProductData))
    }
    resetproductData()
    const {
      refFormObserver,
      getValidationState,
    } = formValidation(resetproductData)

    return {
      onSubmit,
      countryOptions,
      refFormObserver,
      getValidationState,
      currencyOptions,
      categoriesData,
      managersList,

      brandsData,
      taxTypesData,
      unitOptions,
      snowOption: {
        theme: 'snow',
      },
      priceInputConfig: {
        numeral: true,
        numeralDecimalScale: 4,
        numeralThousandsGroupStyle: 'none',
      },
      productData,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
